import { JustpayTaskEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-task-endpoint-service"

export class JustpayTaskService {
    constructor () {
        this.justpayTaskEndpointService = new JustpayTaskEndpointService()
    }

    async changeTask (request) {
        await this.justpayTaskEndpointService.changeTask(request)
    }

    async createTask (request) {
        await this.justpayTaskEndpointService.createTask(request)
    }

    async getTask (taskId) {
        const response = await this.justpayTaskEndpointService.getTasks({ id: taskId })
        return response.data.length > 0 ? response.data[0] : []
    }

    async getTasks (arg) {
        return this.justpayTaskEndpointService.getTasks(arg)
    }
}
